import React, { useEffect, useState } from "react";
import "./App.css";
import BotCollection from "./BotCollection";
import YourBotArmy from "./YourBotArmy";
import SortBar from "./SortBar";

function App() {
    const [bots, setBots] = useState([]);
    const [army, setArmy] = useState([]);
    const [sortItem, setSortItem] = useState("health")

    useEffect(() => {
        fetch('http://localhost:8001/bots')
          .then(res => res.json())
          .then(data => setBots(data))
          .catch(error => console.error("Fetch error:", error));
      }, []);
   
      function handleDelete(id) {
        fetch(`http://localhost:8001/bots/${id}`, {
            method: 'DELETE',
        })
            .then(response => response.json())
            .then(() => {
                setBots(prevBots => prevBots.filter(bot => bot.id !== id));
            });
            }

    function handleSortChange(criteria) {
        setSortItem(criteria); 
    }

    const sortedBots = [...bots].sort((a, b) => {
        if (typeof a[sortItem] === 'number') {
            return b[sortItem] - a[sortItem];
        } else {
            return a[sortItem].localeCompare(b[sortItem]);
        }
    });

    function handleRemoveFromArmy(bot) {
        setArmy(botArmy => botArmy.filter(bt => bt.id !== bot.id));
    }
      
    function addToArmy(bot) {
        const alreadyInArmy = army.some(b => b.id === bot.id);
        if (!alreadyInArmy) {
            setArmy(array => [...array, bot]);
        }
    }

    return (
        <>
            <YourBotArmy
                army={army}
                onRemoveBot={handleRemoveFromArmy}
            />
            <SortBar 
                onSortChange={handleSortChange}
            />
            <BotCollection 
                bots={sortedBots}
                onBotClick={addToArmy}
                onDeleteBot={handleDelete}
            />
        </>
    )
}

export default App;